/**
 * Created by caterina on 24-05-17.
 */

import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Http } from '@angular/http';
import { AuthenticationService } from '../_shared/services/authentication.service';
import { SteelProfile } from './steel-profile';
import { Observable } from 'rxjs/Observable';
@Injectable()
export class SteelProfileService {
  private url = `${environment.apiUrl}/steel-profile/`;

  constructor(private http: Http,
    private authService: AuthenticationService) {
  }

  /*TODO handle errors*/


  getAll(): Observable<SteelProfile[]> {
    return this.http.get(this.url, this.authService.getAuthOptions()).map((res) => res.json());
  }

  getType(type: number): Observable<any[]> {
    const url = `${this.url}?type=${type}`;
    return this.http.get(url, this.authService.getAuthOptions()).map((res) => res.json());
  }

  getPurlins(): Observable<any> {
    const url = `${this.url}purlin/`;
    return this.http.get(url, this.authService.getAuthOptions()).map((res) => res.json());
  }

  getWindColumns(): Observable<any> {
    const url = `${this.url}windColumn/`;
    return this.http.get(url, this.authService.getAuthOptions()).map((res) => res.json());
  }

  getCrossBracingsEaveStruct(): Observable<any> {
    const url = `${this.url}crossBracingEaveStruct/`;
    return this.http.get(url, this.authService.getAuthOptions()).map((res) => res.json());
  }

  get(id: number): Observable<SteelProfile> {
    const url = `${this.url}${id}/`;
    return this.http.get(url, this.authService.getAuthOptions()).map((res) => res.json());
  }

  update(profile: SteelProfile): Observable<SteelProfile> {
    const url = `${this.url}${profile.id}/`;
    return this.http.put(url, JSON.stringify(profile), this.authService.getAuthOptions()).map((res) => res.json());

  }

  create(profile: SteelProfile): Observable<SteelProfile> {
    return this.http.post(this.url, JSON.stringify(profile), this.authService.getAuthOptions()).map((res) => res.json());
  }

  delete(id: number): Observable<SteelProfile> {
    const url = `${this.url}${id}/`;
    return this.http.delete(url, this.authService.getAuthOptions()).map((res) => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile.service.ts